import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, first, take } from 'rxjs/operators';

import { AuthCheckService } from '@auth/services/auth-check.service';
import { DadosLoginService } from '@auth/services/dados-login.service';
import { DarkThemeService } from '@core/theme/dark-theme.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AvailabilityService } from '@services/availability.service';
import { AlertService } from '@shared/alert/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AuthApiService } from '../../services/auth-api.service';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    isCheckAvailable: boolean = true;
    show_password = false;

    err_msg = '';

    isdev = !environment.production;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authApiService: AuthApiService,
        private dadosLoginService: DadosLoginService,
        private authCheckService: AuthCheckService,
        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private modalService: NgbModal,
        public availService: AvailabilityService,
        public darkThemeService: DarkThemeService
    ) {}

    ngOnInit() {
        // get return url from route parameters or default to '/'
        this.returnUrl =
            this.route.snapshot.queryParams['returnUrl'] || '/colaborador';

        // redirect to home if already logged in
        if (this.authCheckService.isLogged) {
            this.router.navigate([this.returnUrl]);
            return;
        }

        this.createLoginForm();
        this.checkAvailable();
    }

    createLoginForm() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
        });
    }

    checkAvailable() {
        this.availService
            .check()
            .pipe(
                take(1),
                finalize(() => {
                    this.isCheckAvailable =
                        this.availService.api_available.value;

                    if (!this.isCheckAvailable) {
                        this.loginForm.disable();
                    }
                })
            )
            .subscribe();
    }

    reload() {
        window.location.reload();
    }
    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.spinner.show();
        this.authApiService
            .login({
                username: this.f.username.value,
                password: this.f.password.value,
            })
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.alertService.error('Erro na autenticação');
                    this.spinner.hide();
                    if (error['error'].non_field_errors) {
                        this.err_msg = error['error'].non_field_errors[0];
                    } else {
                        this.err_msg =
                            error['name'] + '\n' + error['statusText'];
                        switch (error.status) {
                            case 0:
                                this.err_msg =
                                    'Servidor de autenticação indisponível';
                        }
                    }
                }
            );
    }

    //exibe mensagem ao enviar a request para redefinir senha pegando no parametro o cpf digitado
    redefinirSenha() {
        const cpf = this.loginForm.get('username').value;
        this.spinner.show();

        this.authApiService
            .esqueceuSenha(cpf)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe({
                next: res => {
                    this.alertService.success(res['message']);
                },
                error: err => {
                    this.alertService.error(err);
                },
            });
    }

    open(content) {
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'x',
        });
    }
}
